module.exports = __webpack_public_path__ + "media/swampling.b8b6e839.mp3";